const reviewsRespond = {
  en: {
    translation: {
      reviews_trend: "Average evaluation trend",
      reviews: "Reviews",
      evaluation: "Your evaluations",
      overview: "Overview",
      number_on_quality: "Number of reviews filtered by quality",
      reviewed_as: "Reviewed as ",
      checkin_made: "Check-in date ",
      no_text_review: "Customer didn't add any comment",
      owner_reply: "Owner reply",
      respond: "Respond to review",
      done: "Done",
      inappropriate: "It's inappropriate",
      abusive: "It's abusive or harmful",
      privacy: "It's a violation of privacy",
      review_reported_title: "You reported the review",
      review_reported_text:
        "We got your report, please wait until we will verify it",
      review_reported_error_title: "Error while reporting",
      review_reported_error_text:
        "Something went wrong while trying to report the review",
      reviews_trend_title: "Average evaluation trend",
      panoramic: "Overview rating",
      your_scores: "Your evaluations",
      your_scores_text: "Number of reviews divided by score"
    }
  },
  it: {
    translation: {
      reviews_trend:
        "Andamento della valutazione media in base alle recensioni ricevute",
      reviews: "Recensioni",
      evaluation: "Le tue valutazioni",
      overview: "Panoramica",
      number_on_quality: "Numero di recensioni suddivisi per qualità",
      reviewed_as: "Recensito come ",
      checkin_made: "Check-in effettuato il ",
      no_text_review: "Il cliente non ha rilasciato nessun commento",
      owner_reply: "Risposta dell'owner",
      respond: "Rispondi alla recensioni",
      done: "Fatto",
      inappropriate: "Non è appropriato/a",
      abusive: "Contiene materiale offensivo, dannoso o osceno",
      privacy: "Viola la privacy",
      review_reported_title: "Hai segnalato la recensione",
      review_reported_text:
        "Abbiamo ricevuto la tua segnalazione, la stiamo verificando",
      review_reported_error_title: "Errore nella segnalazione",
      review_reported_error_text:
        "Qualcosa è andato storto durante la segnalazione",
      reviews_trend_title:
        "Andamento della valutazione media in base alle recensioni ricevute",
      panoramic: "Panoramica",
      your_scores: "Le tue valutazioni",
      your_scores_text: "Numero di recensioni suddivise per qualità"
    }
  }
};

export default reviewsRespond;
